import { IconInfoCircle } from "@tabler/icons-react";
import { useTranslations } from "next-intl";

export const DelveryDateBanner = () => {
  const t = useTranslations("cart.configuration");

  return (
    <div className="rounded-xl border border-border bg-brand-white p-4">
      <div className="flex items-start gap-x-3 md:items-center">
        <div className="relative flex aspect-square h-12 w-12 items-center justify-center rounded-full bg-brand-blue/[8%]">
          <div className="absolute top-1/2 left-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-blue/[12%]" />
          <IconInfoCircle className="absolute top-1/2 left-1/2 size-6 -translate-x-1/2 -translate-y-1/2 text-brand-black" />
        </div>
        <div className="w-[70%] space-y-1 md:w-full">
          <p className="font-medium text-lg leading-[26px]">
            {t("deliveryTimeBannerTitle")}
          </p>
          <p className="text-sm leading-[22px]">
            {t("deliveryTimeBannerDescription")}
          </p>
        </div>
      </div>
    </div>
  );
};
